import * as types from '../mutation-types'

const packagesPageSize = 10

export const mutations = {
  [types.SET_STATS_PERIOD] (state, period) {
    state.period = period
  },
  [types.SET_STATS_SOURCE_TYPE] (state, sourceType) {
    state.sourceType = sourceType
  },
  [types.SET_GETTING_DOWNLOADS_BY_DAY] (state, flag) {
    state.gettingDownloadsByDay = flag
  },
  [types.CLEAR_DOWNLOADS_BY_DAY] (state) {
    state.downloadsByDay = []
  },
  [types.RECEIVE_DOWNLOADS_BY_DAY] (state, params) {
    state.downloadsByDay = params.downloadsByDay
  },
  [types.SET_GETTING_LICENSES_USED] (state, flag) {
    state.gettingLicensesUsed = flag
  },
  [types.CLEAR_LICENSES_USED] (state) {
    state.licensesUsed = []
    state.licensesCount = undefined
    state.currentLicensesPage = undefined
  },
  [types.RECEIVE_FIRST_LICENSES_USED] (state, params) {
    state.licensesUsed = params.licensesUsed
    state.licensesCount = params.licensesCount
    state.currentLicensesPage = 1
  },
  [types.RECEIVE_NEXT_LICENSES_USED] (state, params) {
    state.licensesUsed = state.licensesUsed.concat(params.licensesUsed)
    state.currentLicensesPage = params.page
  },
  [types.SET_GETTING_PACKAGES_DOWNLOADED] (state, flag) {
    state.gettingPackagesDownloaded = flag
  },
  [types.CLEAR_PACKAGES_DOWNLOADED] (state) {
    state.packagesDownloaded = []
    state.packagesDownloadedCount = undefined
    state.currentPackagesDownloadedPage = undefined
  },
  [types.RECEIVE_FIRST_PACKAGES_DOWNLOADED] (state, params) {
    state.packagesDownloaded = params.packagesDownloaded
    state.packagesDownloadedCount = params.packagesDownloadedCount
    state.currentPackagesDownloadedPage = 1
  },
  [types.RECEIVE_NEXT_PACKAGES_DOWNLOADED] (state, params) {
    state.packagesDownloaded = state.packagesDownloaded.concat(params.packagesDownloaded)
    state.currentPackagesDownloadedPage = params.page
  },
}

const module = (HTTP) => ({
  state: {
    period: 30, // # of days of stats we're showing
    gettingDownloadsByDay: false,
    downloadsByDay: [],
    gettingLicensesUsed: false,
    licensesUsed: [],
    licensesCount: undefined,
    currentLicensesPage: undefined,
    gettingPackagesDownloaded: false,
    packagesDownloaded: [],
    packagesDownloadedCount: undefined,
    currentPackagesDownloadedPage: undefined,
    sourceType: 'r',
  },
  mutations,
  actions: {
    clearDownloadsByDay ({ commit }) {
      commit(types.CLEAR_DOWNLOADS_BY_DAY)
    },
    async getDownloadsByDay ({ commit }, params) {
      try {
        commit(types.SET_GETTING_DOWNLOADS_BY_DAY, true)
        const response = await HTTP.get(`/metrics/daily?_sourceType=${params.sourceType}&_days=${params.period}`)
        const downloadsByDay = response.data
        commit(types.RECEIVE_DOWNLOADS_BY_DAY, { downloadsByDay: downloadsByDay })
        commit(types.SET_GETTING_DOWNLOADS_BY_DAY, false)
      } catch (e) {
        commit(types.SET_GETTING_DOWNLOADS_BY_DAY, false)
        console.log(e)
      }
    },
    async getFirstLicensesUsed ({ commit }, params) {
      try {
        commit(types.SET_GETTING_LICENSES_USED, true)
        commit(types.CLEAR_LICENSES_USED)
        const search = params.searchString ? `&name_like=${params.searchString}` : ''
        const response = await HTTP.get(`/metrics/licenses?_sourceType=${params.sourceType}&_days=${params.period}&_sort=${params.sortBy}&_order=${params.sortOrder}&_limit=${packagesPageSize}${search}`)
        const licensesUsed = response.data
        const count = response.headers['x-total-count'] || 1
        commit(types.RECEIVE_FIRST_LICENSES_USED, { licensesUsed: licensesUsed, licensesCount: +count })
        commit(types.SET_GETTING_LICENSES_USED, false)
      } catch (e) {
        commit(types.SET_GETTING_LICENSES_USED, false)
        console.log(e)
      }
    },
    async getNextLicensesUsed ({ commit, state }, params) {
      try {
        commit(types.SET_GETTING_LICENSES_USED, true)
        const page = state.currentLicensesPage + 1
        const search = params.searchString ? `&name_like=${params.searchString}` : ''
        const response = await HTTP.get(`/metrics/licenses?_sourceType=${params.sourceType}&_days=${params.period}&_sort=${params.sortBy}&_order=${params.sortOrder}&_page=${page}&_limit=${packagesPageSize}${search}`)
        const licensesUsed = response.data
        commit(types.RECEIVE_NEXT_LICENSES_USED, { licensesUsed: licensesUsed, page: page })
        commit(types.SET_GETTING_LICENSES_USED, false)
      } catch (e) {
        commit(types.SET_GETTING_LICENSES_USED, false)
        console.log(e)
      }
    },
    async getFirstPackagesDownloaded ({ commit }, params) {
      try {
        commit(types.SET_GETTING_PACKAGES_DOWNLOADED, true)
        commit(types.CLEAR_PACKAGES_DOWNLOADED)
        const search = params.searchString ? `&name_like=${params.searchString}` : ''
        const response = await HTTP.get(`/metrics/packages?_sourceType=${params.sourceType}&_days=${params.period}&_sort=${params.sortBy}&_order=${params.sortOrder}&_limit=${packagesPageSize}${search}`)
        const packagesDownloaded = response.data
        const count = response.headers['x-total-count'] || 1
        commit(types.RECEIVE_FIRST_PACKAGES_DOWNLOADED, { packagesDownloaded: packagesDownloaded, packagesDownloadedCount: +count })
        commit(types.SET_GETTING_PACKAGES_DOWNLOADED, false)
      } catch (e) {
        commit(types.SET_GETTING_PACKAGES_DOWNLOADED, false)
        console.log(e)
      }
    },
    async getNextPackagesDownloaded ({ commit, state }, params) {
      try {
        commit(types.SET_GETTING_PACKAGES_DOWNLOADED, true)
        const page = state.currentPackagesDownloadedPage + 1
        const search = params.searchString ? `&name_like=${params.searchString}` : ''
        const response = await HTTP.get(`/metrics/packages?_sourceType=${params.sourceType}&_days=${params.period}&_sort=${params.sortBy}&_order=${params.sortOrder}&_page=${page}&_limit=${packagesPageSize}${search}`)
        const packagesDownloaded = response.data
        commit(types.RECEIVE_NEXT_PACKAGES_DOWNLOADED, { packagesDownloaded: packagesDownloaded, page: page })
        commit(types.SET_GETTING_PACKAGES_DOWNLOADED, false)
      } catch (e) {
        commit(types.SET_GETTING_PACKAGES_DOWNLOADED, false)
        console.log(e)
      }
    },
  },
  getters: {
    downloadsByDay: (state) => {
      return state.downloadsByDay.map(dbd => {
        return { x: dbd.day, y: dbd.total_downloads }
      })
    },
    cumulativeDownloadsByDay: (state) => {
      let cum = 0
      return state.downloadsByDay.map(dbd => {
        cum += dbd.total_downloads
        return { x: dbd.day, y: cum }
      })
    },
    uniqueDownloadsByDay: (state) => {
      return state.downloadsByDay.map(dbd => {
        return { x: dbd.day, y: dbd.unique_downloads }
      })
    },
    totalUniqueDownloadsByDay: (state) => {
      return state.downloadsByDay.map(dbd => {
        return { x: dbd.day, y: dbd.unique_running_total }
      })
    },
  },
})

export default {
  module,
}
